import './App.css';
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Home from './pages/Home/Home';
import Policy from './pages/Policy/Policy';
import NavBar from './Components/NavBar/NavBar';
import MobileNavBar from './Components/MobileNavBar/MobileNavBar'
import Footer from './Components/Footer/Footer'
import Book from './pages/Book/Book'; 
import { useEffect, useState } from "react";
import { getProducts } from './services/OnlineStore';
import useProductsStore from './states/products';
import useStaffStore from './states/staff';
import Schedule from './pages/schedule/Schedule'; 
import { getStaff } from './services/Calendar'; 
import CheckoutPage from './pages/Checkout/[timeSlot]';
import logo from './assets/logo.svg'
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure/PaymentFailure';
import Login from './pages/CustomerPortal/Login'
import CustomerPortalInfo from './pages/CustomerPortal/Info'; 
import ProtectedCustomerRoute from './Components/Auth/ProtectedCustomerRoute';
import { useIsSmallScreen } from './hooks/useIsSmallScreen';
import CustomerPortalAppointments from './pages/CustomerPortal/Appointments.jsx'; 


function App() {
  const navigate = useNavigate();
  const setProductsStore = useProductsStore((state) => state.setProducts);
  const setStaffStore = useStaffStore((state) => state.setStaff);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const productsList = await getProducts();
        setProductsStore(productsList);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    }

    fetchProducts();
  }, []);
  
  useEffect(() => {
    async function fetchStaff() {
      try {
        const staffList = await getStaff();
        setStaffStore(staffList);
      } catch (error) {
        console.error("Error fetching staff:", error);
      }
    }

    fetchStaff();
  }, []);

  const navItemsLeft = [
    { name: "Home", path: "/home", scrollToTop: true },
    { name: "About", path: "#about", scrollToTop: false },
    { name: "My Work", path: "#portfolio", scrollToTop: false },
  ];

  const navItemsRight = [
    { name: "Services", path: "#services", scrollToTop: false },
    { name: "Policies & Ethics", path: "/policy", scrollToTop: true },
    { name: "Book Now", path: "/book", scrollToTop: true, style: {backgroundColor: "var(--action-primary)", color: "var(--fg-on-action-primary)"} },
  ];

  const mobileNavItems = [
    { name: "Home", path: "/home", scrollToTop: true },
    { name: "About", path: "#about", scrollToTop: false },
    { name: "My Work", path: "#portfolio", scrollToTop: false },
    { name: "Services", path: "#services", scrollToTop: false },
    { name: "Policies & Ethics", path: "/policy", scrollToTop: true },
    { name: "Book Now", path: "/book", scrollToTop: true, style: {backgroundColor: "var(--action-primary)", color: "var(--fg-on-action-primary)"} },
    { name: "Customer Portal", path: "/login", scrollToTop: true}
  ]

  const navLogo = {
    image: logo,
    path: "/home"
  }

  const isSmallScreen = useIsSmallScreen();

  return (
    <div className="App">
      {isSmallScreen ? (
        <MobileNavBar
          navItems={mobileNavItems}
          navLogo={navLogo}
        />
      ):(
        <NavBar 
          navItemsLeft={navItemsLeft} 
          navItemsRight= {navItemsRight} 
          navLogo={navLogo}
        />
      )}
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/book" element={<Book />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/checkout/:timeSlot" element={<CheckoutPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
        <Route path="/login" element = {<Login />} />
        <Route path="/customer-portal-appointments" element=
          {
          <ProtectedCustomerRoute>
            <CustomerPortalAppointments />
          </ProtectedCustomerRoute>
        }
          />
        <Route
          path="/customer-portal-info"
          element={(
            <ProtectedCustomerRoute>
              <CustomerPortalInfo />
            </ProtectedCustomerRoute>
          )}
        />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
